import { CerebroDrawer } from '../../../shared/components';
import { EmptyGuid } from '../../../shared/constants';
import { TermSheet, TermSheetFacility } from '../../../shared/models';
import { FacilityForm } from './FacilityForm';

interface AddFacilityDrawerProps {
	dealGuid: string | undefined;
	dataRoomGuid: string | undefined;
	termSheetGuid: string | undefined;
	revisionGuid: string | undefined;
	termSheet: TermSheet;
	isOpen: boolean;
	close: () => void;
}

export const AddFacilityDrawer: React.FC<AddFacilityDrawerProps> = ({
	dealGuid,
	dataRoomGuid,
	termSheetGuid,
	revisionGuid,
	termSheet,
	isOpen,
	close,
}) => {
	const newFacility = {
		id: 0,
		guid: EmptyGuid,
		facilityType: 'Unknown',
		structureTranche: termSheet.defaultStructureTranche,
	} as TermSheetFacility;

	return (
		<CerebroDrawer open={isOpen} onClose={close}>
			<FacilityForm
				dealGuid={dealGuid}
				dataRoomGuid={dataRoomGuid}
				termSheetGuid={termSheetGuid}
				revisionGuid={revisionGuid}
				facility={newFacility}
				close={close}
			/>
		</CerebroDrawer>
	);
};
